import { get } from "lodash";
import { fetchGet, fetchPost, fetchPut, fetchDelete } from "../api/fetch";
import { addTabHistory } from "../actions/siteEntranceExit/tabHistory";
import { addTab } from "../actions/siteEntranceExit/tabs";
import {
  GLOBAL_PREFERENCES,
  SITE,
  DYNAMIC_TAB,
} from "../constants/siteEntranceExit";
import { API_DATASTORE } from "../constants/api";

/** Data Store Structure
 * key: GLOBAL_PREFERENCES_<section>
 * section = driveInOut | walkInOut
 * content:
 * {
 *    rowsPerPage,
 *    collapsedSections: {},
 *    viewUnmatchedPhotos
 * }
 *
 * key: SITE_<site_id>_<section>
 * content:
 * {
 *    openedTabs: [<tab_id>, <tab_id>, ...],
 *    tabHistory: [<tab_id>, <tab_id>, ...]
 * }
 */

export const getGlobalPreferencesFromState = (name, state) => {
  return {
    rowsPerPage: get(state, [
      "siteEntranceExit",
      name,
      "tabs",
      0,
      "logs",
      "rowsPerPage",
    ]),
    collapsedSections: get(state, [
      "siteEntranceExit",
      name,
      "tabs",
      0,
      "logs",
      "collapsed",
    ]),
    viewUnmatchedPhotos: get(state, ["common", "viewUnmatchedPhotos"]),
  };
};

export const fetchGlobalPreferences = async (dispatch, name) => {
  const defaultPreferences = {
    rowsPerPage: 10,
    collapsedSections: {
      main: true,
      verified: {},
    },
    viewUnmatchedPhotos: false,
  };
  try {
    let preferences = await dataStoreGet(`${GLOBAL_PREFERENCES}_${name}`);
    if (!preferences) {
      await dataStorePost(`${GLOBAL_PREFERENCES}_${name}`, defaultPreferences);
      return defaultPreferences;
    } else {
      if (!preferences.rowsPerPage) {
        preferences.rowsPerPage = defaultPreferences.rowsPerPage;
      }
      if (!preferences.collapsedSections) {
        preferences.collapsedSections = defaultPreferences.collapsedSections;
      }
      if (!preferences.viewUnmatchedPhotos) {
        preferences.viewUnmatchedPhotos =
          defaultPreferences.viewUnmatchedPhotos;
      }
    }
    return preferences;
  } catch (e) {
    console.log(e);
  }
};

export const initSite = async (dispatch, name, siteId) => {
  let initalSiteData = {
    openedTabs: [],
    tabHistory: [],
  };
  try {
    let siteData = await dataStoreGet(`${SITE}_${siteId}_${name}`);
    if (!siteData) {
      await dataStorePost(`${SITE}_${siteId}_${name}`, initalSiteData);
    } else {
      // Restore opened tabs
      for (let i = 0; i < siteData.openedTabs.length; i++) {
        await dispatch(
          addTab(
            name,
            null,
            { ...get(siteData, ["openedTabs", i]), type: DYNAMIC_TAB },
            false,
            false
          )
        );
      }
      // Restore history tabs
      for (let i = 0; i < siteData.tabHistory.length; i++) {
        dispatch(
          addTabHistory(
            name,
            { ...siteData.tabHistory[i], type: DYNAMIC_TAB },
            false
          )
        );
      }
    }
  } catch (e) {
    console.log(e);
  }
};

export const getSiteFromState = (name, state) => {
  return {
    openedTabs: get(state, ["siteEntranceExit", name, "tabs"])
      .filter((t) => t.type === DYNAMIC_TAB)
      .map((t) => ({
        eventGroupId: t.eventGroupId,
        status: t.status,
        zone: t.zone,
      })),
    tabHistory: get(state, ["siteEntranceExit", name, "tabHistory"]).map(
      (t) => ({
        eventGroupId: t.eventGroupId,
        status: t.status,
        zone: t.zone,
      })
    ),
  };
};

export const updateSiteDataStore = async (name, state) => {
  try {
    let siteId = get(state, ["siteEntranceExit", name, "activeSite", "id"]);
    if (siteId) {
      await dataStorePut(
        `${SITE}_${siteId}_${name}`,
        getSiteFromState(name, state)
      );
    }
  } catch (e) {
    console.log(e);
  }
};

export const dataStoreGet = async (key) => {
  try {
    let res = await fetchGet(`ds/usr/${key}`, API_DATASTORE);
    if (res && res.data && res.data.length > 0 && res.data[0].value) {
      return res.data[0].value;
    }
  } catch (e) {
    console.log(e);
  }
};

export const dataStorePost = async (key, value) => {
  try {
    await fetchPost(
      `ds/usr/${key}`,
      { value, versioning: false },
      API_DATASTORE
    );
  } catch (e) {
    console.log(e);
  }
};

export const dataStorePut = async (key, value) => {
  try {
    await fetchPut(`ds/usr/${key}`, value, API_DATASTORE);
  } catch (e) {
    console.log(e);
  }
};

export const dataStoreDelete = async (key, index = null) => {
  try {
    if (!isNaN(index)) {
      await fetchDelete(`ds/usr/${key}/${index}`, {}, API_DATASTORE);
    }
  } catch (e) {
    console.log(e);
  }
};
